/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "In Your Face .Dev",
  title: "Analyze Deep, Code Fast, Ship Faster ⚡",
  subTitle: emoji(
    "A relentless Software Engineer who codes right in your face! 🚀 I build, break, fix, and deploy at lightning speed. Ruby, Rails, PHP, Laravel Python, Docker - you name it, I ship it. No BS, just clean code and attitude."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1-2lT9QmOhWrCkDBL0YfhT4HbdAJO_OSo/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/inyourface-dev",
  linkedin: "https://www.linkedin.com/in/inyourface-dev/",
  gmail: "vriverad@gmail.com",
  gitlab: "https://gitlab.com/inyourface-dev",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: false // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "UNSTOPPABLE FULL STACK DEVELOPER WHO SHIPS CODE LIKE THERE'S NO TOMORROW",
  skills: [
    emoji(
      "⚡ Build full-stack applications from scratch to production that handle millions in revenue"
    ),
    emoji("⚡ Ruby on Rails, PHP Laravel, Python - backend systems that actually scale"),
    emoji(
      "⚡ DevOps, Docker, microservices, and cloud integrations shipped at lightning speed"
    ),
    emoji("⚡ Lead international dev teams and turn impossible deadlines into 'hold my coffee' moments")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "ruby",
      fontAwesomeClassname: "fas fa-gem"
    },
    {
      skillName: "rails",
      fontAwesomeClassname: "fas fa-train"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "elasticsearch",
      fontAwesomeClassname: "fas fa-search"
    },
    {
      skillName: "postgresql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mysql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Costa Rica",
      logo: require("./assets/images/ucrLogo.png"),
      subHeader: "Master in Cognitive Science (Candidate)",
      duration: "January 2012 - Ongoing",
      desc: "Advanced research in cognitive computing and human-machine interaction at Central America's most prestigious university.",
      descBullets: [
        "Cognitive Science research with practical AI applications",
        "Human-machine interaction and cognitive computing research"
      ]
    },
    {
      schoolName: "University of Costa Rica",
      logo: require("./assets/images/ucrLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "January 2000 - July 2005",
      desc: "Solid foundation in algorithms, data structures, and software engineering. Professor and IT leader managing 300+ PCs.",
      descBullets: [
        "Computer Science fundamentals with practical application",
        "Professor experience teaching programming and computer processing",
        "IT support leadership managing 300+ PCs for student labs. They were a bunch of punks always trying to hack us (I loved those guys. I learned to stay aware)"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Architecture Design", //Insert stack or technology you have experience in
      progressPercentage: "100%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "100%"
    },
    {
      Stack: "DevOps",
      progressPercentage: "100%"
    },
    {
      Stack: "Frontend",
      progressPercentage: "100%"
    },
    {
      Stack: "QA",
      progressPercentage: "100%"
    },
    {
      Stack: "Security",
      progressPercentage: "100%"
    },
    {
      Stack: "Humbleness",
      progressPercentage: "105%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Principal Developer",
      company: "IBM Aspera-Orchestrator",
      companylogo: require("./assets/images/ibmLogo.png"),
      date: "September 2021 – Present",
      desc: "Building code for Aspera's world-class zero-code workflow engine at lightning speed. L3 specialist handling severity-one escalations when everything's on fire.",
      descBullets: [
        "⚡ Upgraded Ruby 3.1.2 and Rails 6 - modernization at full speed",
        "🎯 Strategic contributor in product evolution meetings",
        "🌎 Leading US and Latin American teams through rapid project delivery"
      ]
    },
    {
      role: "Senior Full-Stack Developer & Team Lead",
      company: "Echecks.com",
      companylogo: require("./assets/images/deluxeLogo.webp"),
      date: "September 2019 – September 2021",
      desc: "Led 14-person international dev team with no BS approach. Built fintech platform from ZERO in complex regulatory environment that actually works.",
      descBullets: [
        "🔨 Shipped complex third-party integrations for massive check printing operations",
        "🛠️ QA partnership specialist - fixed production bugs at lightning speed",
        "💳 Built secure fintech solutions handling massive transaction volumes"
      ]
    },
    {
      role: "Tech Lead & Architect",
      company: "Ellevest (NY Top 20 Startup)",
      companylogo: require("./assets/images/ellevestLogo.png"),
      date: "August 2018 – February 2019",
      desc: "Led 11-person microservices team across NYC and Costa Rica. Built HTTP service layer that eliminated single-custodian dependency at speed.",
      descBullets: [
        "🚀 Microservices architecture with Docker and CI/CD that scales",
        "💥 Multi-custodian communication that actually works (Folio, CorePro)",
        "🔥 Deposit and Transfer flows shipped fast and clean"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "STARTUPS AND COMPANIES WHERE I SHIPPED CODE THAT ACTUALLY MADE MONEY",
  projects: [
    {
      image: require("./assets/images/ibmLogo.png"),
      projectName: "IBM Aspera-Orchestrator",
      projectDesc: "⚡ Zero-code workflow automation platform serving Fortune 500 companies as backbone infrastructure. Building plugins and modernizing platforms at lightning speed.",
      footerLink: [
        {
          name: "Learn More",
          url: "https://www.ibm.com/products/aspera"
        }
      ]
    },
    {
      image: require("./assets/images/paloaltoLogo.png"),
      projectName: "PaloAltoNetworks Acquisition",
      projectDesc: "🚀 6-MONTH SPRINT: Built Aperture data security SaaS from scratch → $1.6M funding → Successful acquisition by PaloAltoNetworks. 100% test coverage, 20+ cloud integrations.",
      footerLink: [
        {
          name: "Success Story",
          url: "https://www.paloaltonetworks.com/"
        }
      ]
    },
    {
      image: '',
      projectName: "Echecks.com Fintech Platform",
      projectDesc: "💳 Built secure fintech platform from ZERO handling massive transaction volumes. Led 14-person international team. Complex third-party integrations for massive check printing operations.",
      footerLink: [
        {
          name: "Digital Checks",
          url: "https://echecks.com/"
        }
      ]
    },
    {
      image: require("./assets/images/ellevestLogo.png"),
      projectName: "Ellevest Investment Platform",
      projectDesc: "💼 Top 20 NYC startup infrastructure. Microservices architecture with Docker and CI/CD. Multi-custodian integration eliminating single points of failure. Led 11-person team across NYC and Costa Rica.",
      footerLink: [
        {
          name: "Women's Investment",
          url: "https://www.ellevest.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements That Ship 🏆 "),
  subtitle:
    "Real achievements with real impact - no BS, just results that made companies millions!",

  achievementsCards: [
    {
      title: "$1.6M Acquisition Success",
      subtitle:
        "Built Aperture data security SaaS from scratch in 6 months → $1.6M funding → Successful acquisition by PaloAltoNetworks. 100% test coverage, 20+ cloud integrations.",
      image: require("./assets/images/nextuLogo.webp"),
      imageAlt: "PaloAltoNetworks Acquisition",
      footerLink: [
        {
          name: "Learn More",
          url: "https://www.paloaltonetworks.com/"
        }
      ]
    },
    {
      title: "Democracy Platform Victory",
      subtitle:
        "Built liquid democracy platform that helped Gente Montes de Oca win 2016 municipal elections in influential Costa Rica region. SSO integration with Supreme Court of Elections.",
      image: require("./assets/images/loomioLogo.png"),
      imageAlt: "Democracy Platform",
      footerLink: [
        {
          name: "Digital Democracy",
          url: "#"
        }
      ]
    },
    {
      title: "International Team Leadership",
      subtitle: "Led dev teams across multiple continents: 14-person team at Echecks.com, 11-person team at Ellevest, global teams at IBM. Shipped code that scales.",
      image: require("./assets/images/ibmLogo.png"),
      imageAlt: "Team Leadership",
      footerLink: [
        {name: "Experience", url: "#workExperience"}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to My Resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Got a project that needs shipping fast? Let's build something that actually works!",
  number: "",
  email_address: "code@inyourface.dev",
  actual_email: "vriverad@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
